import { render, staticRenderFns } from "./baijing.vue?vue&type=template&id=e6807242&scoped=true&"
import script from "./baijing.vue?vue&type=script&lang=ts&"
export * from "./baijing.vue?vue&type=script&lang=ts&"
import style0 from "./baijing.vue?vue&type=style&index=0&id=e6807242&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6807242",
  null
  
)

export default component.exports